<template>
  <v-layout justify-center class="pagemargin page">
    <v-flex>
      <vsettings
        v-if="activeAdmin !== null"
        :settings="component"
        :schema="settings"
      ></vsettings>
    </v-flex>
  </v-layout>
</template>

<script>
import vsettings from "@/components/Settings.vue";
import settingsSchema from "@/schemas/admin.json";
import componentSchema from "@/schemas/component.json";
import { mapState } from "vuex";

export default {
  components: {
    vsettings
  },
  props: {
    resource: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: () => ({
    activeAdmin: null,
    settings: null,
    component: null
  }),
  computed: {
    ...mapState({
    }),
    queryString() {
      return this.$route.query;
    }
  },
  watch: {
    resource: {
      handler: function() {
        this.ReadResources();
      },
      deep: true
    },
    queryString: {
      handler: function() {
        this.changeSettings(this.$route.query.component);
      },
      deep: true
    }
  },
  mounted() {
    this.changeSettings(this.$route.query.component);
    //console.log("this.$route.query.component = " + this.$route.query.component);
  },
  methods: {
    changeSettings(settings) {
      this.settings = settingsSchema[settings]; //default; this.admin becomes an obj with the table column values
      //console.log("this.admin" + JSON.stringify(this.admin, null, 2));
      this.component = componentSchema[settings]; // this.component becomes an obj with the component values
      this.activeAdmin = settings;
    },
  }
};
</script>

<style scoped></style>
